






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Linkbutton extends Vue
{
	@Prop() label!: string;

	click()
	{
		this.$emit("click", event);
	}
}
